export default __webpack_public_path__ + "static/hp-brand-deck-21-d5a0dc3ee944bf5fe9594a91ef6a3ace.png";